import { render, staticRenderFns } from "./driverBankCard.vue?vue&type=template&id=126d6a10&scoped=true&"
import script from "./driverBankCard.vue?vue&type=script&lang=js&"
export * from "./driverBankCard.vue?vue&type=script&lang=js&"
import style0 from "./driverBankCard.vue?vue&type=style&index=0&id=126d6a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d6a10",
  null
  
)

export default component.exports